import styled from "styled-components";

const styleScroll = `
overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c4c4c4;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

`;

const positionFixedModalStyle = `
border-radius: 20px;
  position: fixed;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  background-color: rgb(255 255 255);
  transition: opacity 8.5s ease, visibility 6.5s ease;
  padding: 20px;
  box-shadow: rgba(255, 255, 255, 0.1) 0px 1px 1px 0px inset,
    rgba(50, 50, 93, 0.25) 0px 50px 100px -20px,
    rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;
`;

export const Container = styled.div`
  .display-flex {
    display: flex;
  }
  .margin-5 {
    margin: 5px;
  }
`;

export const TableFilterNF = styled.div`
  width: 95.5%;
  padding: 10px;
  margin-left: 20px;
  position: relative;
  top: 35px;

  .width-120 {
    width: 220px;
  }

  .style-select {
    padding: 0 35px;
    height: 30px;
    border: none;
    background: #0361a7;
    color: #fff;
    border-radius: 4px;
    outline: none;
  }

  .btn-to-generate-das {
    padding: 0 20px;
    height: 30px;
    border: none;
    outline: none;
    border-radius: 4px;
    background: #fbc00d;
    color: #ffffff;
  }

  .modalInfo {
    padding: 10px;
    text-align: center;
    width: 100%;
    color: #0361a7;
    font-size: 18px;
  }

  .vlrFat {
    text-align: center;
    font-size: 16px;
  }

  .modalTitle {
    padding: 0 10px;
    width: 100%;
  }
`;

export const DasContainer = styled.div`
display:flex;
width: 97.5%;
background:#fff;
height: auto;
margin:10px;
`;

export const DasCommentContainer = styled.div`
  width: 30%;
  height: 550px;
  padding: 10px;
  margin: 5px;
`;

export const XmlContainer = styled.div`
  width: 70%;
  padding: 10px;
  margin: 10px;
  background: #f8f8f8;
  border-radius: 8px;
`;

export const ContainerField = styled.div`
  .title-tabs {
    padding: 10px 0;
    color: #999999;
    font-size: 18px;
    font-weight: 300;
  }
`;

export const ModalValorFaturamento = styled.div`
  width: 320px;
  margin: 5px;
  height: 470px;
  top: 55%;

  ${positionFixedModalStyle}

  .title {
    padding: 10px;

    label {
      color: #0361a7;
    }

    span {
      position: relative;
      top: 5px;
      color: #898989;
    }
  }

  .style-menu {
    width: 100%;
    border-radius: 8px;
    background: transparent;
    border: none;
  }

  ${styleScroll}

  @media only screen and (max-width: 500px) {
    left: 40%;
    width: 200px;
    height: 500px;
    padding: 15px;
    font-size: 12px !important;
  }
`;

export const ModalRegistroNotas = styled.div`
    width: 500px;
    margin: 5px;
    height: 550px;
    top: 60%;

    ${positionFixedModalStyle}

  .title {
    padding: 10px;

    label {
      color: #504f4f;
    }

    span {
      position: relative;
      top: 5px;
      color: #898989;
    }
  }

  ${styleScroll}

  @media only screen and (max-width: 500px) {
    left: 40%;
    width: 200px;
    height: 500px;
    padding: 15px;
    font-size: 12px !important;
  }
`;

export const ContainerModal = styled.div`
  .display-flex {
    display: flex;
  }
  .width-100 {
    width: 100%;
  }

  .text-align-right {
    text-align: right;
  }
  .margin-5 {
    margin: 5px;
  }

  display: flex;
  border-radius: 8px;
  background: #ffffffab;

  @media (min-width: 768px) {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

export const ModalDadosDaNFE = styled.div`
  width: 600px;
  margin: 5px;
  height: 550px;
  top: 55%;

  ${positionFixedModalStyle}

  .title {
    padding: 10px;

    label {
      color: #504f4f;
    }

    span {
      position: relative;
      top: 5px;
      color: #898989;
    }
  }

  ${styleScroll}

  @media only screen and (max-width: 500px) {
    left: 40%;
    width: 200px;
    height: 500px;
    padding: 15px;
    font-size: 12px !important;
  }
`;

export const ContainerSearch = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  margin: 5px 6px;

  .margin-right {
    margin-right: 5px;
  }
`;
